export const title = "Property ROI Index (2017)";

export const intros = [
  {
    text: (
      <span>
        Aside from offering a guaranteed sale within three months, our goal at
        Nested is to help people get the most value from their homes. We created
        the 2017 Property ROI Index to better understand global variations in
        real estate prices from an investment perspective.
      </span>
    ),
    id: "airbnb-intro",
  },
];

const topButtons = [
  {
    text: "UK",
    country: "uk",
    countryUrl: "uk/london",
  },
  {
    text: "Global",
    country: "global",
    countryUrl: "global/gbp",
  },
];

export const addAdditionalContent = (content) => ({
  ...content,
  topButtons,
  intros: [...intros, ...content.intros],
});
